module.exports = __webpack_public_path__ + "img/office-desk.84b5a4e6.svg";